import { render, staticRenderFns } from "./EditPwd.vue?vue&type=template&id=3007b04f&scoped=true"
import script from "./EditPwd.vue?vue&type=script&lang=js"
export * from "./EditPwd.vue?vue&type=script&lang=js"
import style0 from "./EditPwd.vue?vue&type=style&index=0&id=3007b04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007b04f",
  null
  
)

export default component.exports